import {II18nMap} from "./en";

export const es419: II18nMap = {
	"page_progress_title": "Mi Progreso",
	"page_progress_finished_courses": "Cursos Completados",
	"page_progress_finished_courses_subtitle": "Mira qué cursos has completado hasta ahora",
	"page_progress_active_courses": "Cursos Activos",
	"page_progress_active_courses_subtitle": "Regresa a los cursos en los que participas",
	"page_progress_recent_activity": "Actividad Reciente",
	"page_progress_recent_activity_subtitle": "Mira lo que has completado hasta ahora",
	"page_progress_no_courses": "No hay cursos completados",
	"page_progress_resume_button": "Reanudar",

	"page_settings_title": "Preferencias de Entrenamiento",
	"page_settings_language": "Idioma Preferido",
	"page_settings_english": "Inglés",
	"page_settings_spanish": "Español",
	"page_settings_manage_account": "Administrar detalles de la cuenta",
	"page_settings_save_button": "Guardar",
	"page_settings_cancel_button": "Descartar",

	"page_feed_title": "Mi Feed",

	"page_streak": "Completa todas las tareas pendientes de hoy para aumentar tu racha diaria",

	"search_courses": "Buscar cursos",

	"search_placeholder": "Título del Curso, Título de la Lección, Autor, Descripción de la Lección",

	"nav_feed": "Mi Feed",
	"nav_library": "Biblioteca de Cursos",
	"nav_progress": "Mi Progreso",
	"nav_notes": "Mis Notas",
	"nav_manager": "Gestor de Contenido",

	"nav_mobile_feed": "Feed",
	"nav_mobile_library": "Biblioteca",
	"nav_mobile_progress": "Progreso",
	"nav_mobile_notes": "Notas",

	"menu_profile_settings": "Preferencias de Entrenamiento",
	"menu_profile_account": "Mi Cuenta",
	"menu_profile_support": "Soporte",
	"menu_profile_logout": "Cerrar sesión",

	"common_notes_delete": "Eliminar",
	"common_notes_cancel": "Cancelar",
	"common_notes_edit": "Editar",

	"notifications_settings_updated": "Tus datos han sido actualizados",
	"notifications_wrong_title": "Algo salió mal",
	"notifications_wrong_body": "Por favor, inténtalo de nuevo",
	"notifications_reschedule_success": "Las lecciones se reprogramaron correctamente.",
	"notifications_reschedule_error": "No se pudieron reprogramar las lecciones. Por favor, inténtelo de nuevo.",
	"page_notes_all": "Todas",
	"page_notes_title": "Biblioteca de Notas",
	"common_notes_in": "en",
	"common_notes_search": "Buscar",
	"menu_profile_language_settings": "Preferencias de Idioma",
	"menu_profile_profile": "Perfil",
	"menu_profile_report_issue": "Reportar problema",
	"menu_profile_suggest_feature": "Sugerir una idea",
	"team_progress_widget_completedCourses": "Cursos Completados",
	"team_progress_widget_completedLessons": "Lecciones Completadas",
	"team_progress_widget_timeInTraining": "Tiempo viendo lecciones",
	"team_progress_widget_activeUsers": "Usuarios con completación de lecciones",
	"team_progress_widget_inactiveUsers": "Usuarios sin completación de lecciones",
	"team_progress_widget_usersWithOverdueLessons": "Usuarios con Lecciones Vencidas",
	"team_progress_under_construction": "En Construcción",
	"team_progress_filter_last_week": "Esta semana",
	"team_progress_filter_last_month": "Este mes",
	"team_progress_filter_last_year": "Este año",
	"team_progress_filter_custom_date_range": "Fecha Personalizada",
	"team_progress_filter_archived_users": "Mostrar inactivos",
	"team_progress_calendar_add": "Agregar",
	"team_progress_calendar_cancel": "Cancelar",
	"team_progress_title": "Progreso del Equipo",
	"team_progress_subtitle": "Monitorear el compromiso de aprendizaje y el progreso de los empleados",

	// User enrollment types
	"user_enrollment_type_learner": "Autoasignado",
	"user_enrollment_type_strapi-admin": "Asignado por administrador",
	"user_enrollment_type_auto-assign-schedule": "Asignado automáticamente",
	"user_enrollment_type_prioritize-schedule": "Asignado por prioridad",
	"user_enrollment_type_due-date-schedule": "Asignado con fecha límite",

	// Course categories
	"course_category_Job Training": "Capacitación laboral",
	"course_category_Personal Development": "Desarrollo Personal",
	"course_category_Professional Development": "Desarrollo Profesional",
	"course_category_Safety": "Seguridad",
	"course_category_others": "Otros",

	"completed_lessons_column_firstname": "Nombre",
	"completed_lessons_column_lastname": "Apellido",
	"completed_lessons_column_lesson": "Lección",
	"completed_lessons_column_duration": "Duración",
	"completed_lessons_column_supervisor": "Supervisor",
	"completed_lessons_column_division": "División",
	"completed_lessons_column_job_category": "Categoría de Trabajo",
	"completed_lessons_column_completed_on": "Completado en",
	"completed_lessons_column_enrollment_type": "Tipo de Inscripción",
	"completed_lessons_column_course": "Curso",
	"completed_lessons_column_email": "Email",
	"completed_lessons_column_phone": "Teléfono",
	"completed_lessons_column_job_title": "Título del Trabajo",
	"completed_lessons_column_status": "Estado",
	"completed_lessons_column_streak": "Racha",
	"completed_lessons_viewing_stats_past_week": "VIENDO ESTADÍSTICAS DE LA SEMANA PASADA",
	"completed_lessons_viewing_stats_past_month": "VIENDO ESTADÍSTICAS DEL MES PASADO",
	"completed_lessons_viewing_stats_past_year": "VIENDO ESTADÍSTICAS DEL AÑO PASADO",
	"completed_lessons_viewing_stats_custom_range": "VIENDO ESTADÍSTICAS DE ",
	"completed_lessons_viewing_stats_all_time": "VIENDO ESTADÍSTICAS DE TODO EL TIEMPO",
	"data_grid_export_tooltip": "Viene Pronto",
	"common_content_type": "Tipo de Contenido",
	"common_last_active": "Última vez Activo",
	"common_lessons": "Lecciones",
	"time_in_training": "Tiempo viendo lecciones",
	"completed_lessons": "Lecciones Completadas",
	"no_courses_found": "No se encontraron cursos",
	"common_export": "Exportar",
	"team_progress_one_report_a_time_msg": "Solo puedes descargar un informe a la vez.",
	"team_progress_generating_your_report_msg": "Generando su reporte… No cierre ni actualice esta ventana.",
	"team_progress_download_report_has_started": "Su descarga ha iniciado.",
	"team_progress_download_export_failed": "La exportación falló. Inténtalo de nuevo.",
	"common_overdue_lessons": "Lecciones Vencidas",
	"common_reschedule_overdue": "Reprogramar Vencido",
	"common_reschedule_overdue_tooltip_msg": "Reprogramar lecciones vencidas para usuarios seleccionados",
	"streak_day": "día de racha",
	"streak_days": "días de racha",
	"streak_day_message": "Completa una lección para empezar tu racha.",
	"streak_lesson_completed": "¡Lección de hoy completada! Regresa mañana para continuar tu racha.",
	"streak_day_off": "Tienes el día libre. Tu racha está segura y avanza con buen ritmo.",
	"common_confirm": "Confirmar",
	"bulk_reschedule_modal_title": "Reprogramar lecciones vencidas",
	"bulk_reschedule_modal_body_copy": "Esto reprogramará las lecciones de todos los usuarios seleccionados que tengan asignaciones vencidas.",
	"bulk_reschedule_progress_msg": "Reprogramando lecciones vencidas… No cierre ni actualice esta ventana.",
	"bulk_reschedule_error_msg": "No se pudieron reprogramar las lecciones. Por favor, inténtelo de nuevo.",
	"bulk_reschedule_success_msg": "Lecciones vencidas reprogramadas exitosamente para los usuarios seleccionados",

	"bulk_enrollment_modal_title_other": "Inscribir usuarios en el curso",
	"bulk_enrollment_modal_title_one": "Inscribir usuario en el curso",
	"bulk_enrollment_modal_body_copy_other": "Esto inscribirá a los usuarios seleccionados en el curso. Elija cómo desea programar este curso en su feed de capacitación.",
	"bulk_enrollment_modal_body_copy_one": "Esto inscribirá a el usuario seleccionado en el curso. Elija cómo desea programar este curso en su feed de capacitación.",
	"bulk_enrollment_prioritize_option": "Priorizar en el feed de capacitación",
	"bulk_enrollment_due_date_option": "Fecha de vencimiento",
	"bulk_enrollment_due_date_label": "Fecha de vencimiento",
	"bulk_enrollment_progress_msg": "Inscribiendo usuarios… No cierre ni actualice esta ventana.",
	"bulk_enrollment_error_msg": "No se pudieron inscribir los usuarios. Por favor, inténtelo de nuevo.",
	"notifications_enrollment_success": "Usuarios inscritos exitosamente.",
	"notifications_enrollment_error": "No se pudieron inscribir los usuarios. Por favor, inténtelo de nuevo.",
	"streak_drawer_text_content_tier2.1": "Empezaste una racha.",
	"streak_drawer_text_content_tier2.2": "Deja que la disciplina crezca exponencialmente.",
	"streak_drawer_text_content_tier3.1": "Racha de {{x}} días.",
	"streak_drawer_text_content_tier3.2": "Los hábitos son",
	"streak_drawer_text_content_tier3.3": "el motor silencioso del éxito.",
	"streak_drawer_text_content_tier4.1": "Racha de {{x}} días.",
	"streak_drawer_text_content_tier4.2": "Sin atajos ni excusas",
	"streak_drawer_text_content_tier4.3": "- solo progreso.",
	"common_congrats": "Felicitaciones",
	"common_continue": "Continuar",
	"completion_celebration_congratulations": "Felicitaciones!",
	"completion_celebration_you_completed": "Completaste",
	"completion_celebration_you_did_it": "Lo hiciste!",
	"settings_import_libraries": "Importar Librerías",
	"training_feed_watch_lesson": "Ver lección",
	"training_feed_tap_to_load": "Tocar para cargar",
	"training_feed_nothing_scheduled": "Nada programado",
	"training_feed_overdue": "ATRASADO",
	"training_feed_upcoming": "PRÓXIMO",
	"training_feed_due_today": "VENCE HOY",
	"month_jan": "Ene",
	"month_feb": "Feb",
	"month_mar": "Mar",
	"month_apr": "Abr",
	"month_may": "May",
	"month_jun": "Jun",
	"month_jul": "Jul",
	"month_aug": "Ago",
	"month_sep": "Sep",
	"month_oct": "Oct",
	"month_nov": "Nov",
	"month_dec": "Dic",
	"mark_as_completed": "Marcar como completado",
	"module_tab_overview": "RESUMEN",
	"module_tab_comments": "COMENTARIOS",
	"module_tab_notes": "NOTAS",
	"please_scroll_to_continue": "Por favor, desplázate para continuar",
	"view_more": "Ver más",
	"view_less": "Ver menos",
	"quiz.submit_answers": "Enviar respuestas",
	"quiz.next_question": "Siguiente pregunta",
	"quiz.previous_question": "Pregunta anterior",
	"quiz.back": "Volver",
	"quiz.question_text": "Pregunta",
	"quiz.of_text": "de",
	"quiz.one_answer": "1 respuesta",
	"quiz.multiple_answers": "respuestas",
	"quiz.drag_to_order": "Arrastra las filas al orden correcto",
	"notes.most_recent": "Más recientes",
	"notes.oldest_first": "Más antiguos primero",
	"notes.input_placeholder": "Escribe tu nota privada",
	"comments.load_more": "Cargar más",
	"comments.input_placeholder": "Deja un comentario",
	"comments.reply_to_user": "Responder a {userName}",
	"comments.replies": "respuestas",
	"comments.today": "Hoy",
	"comments.yesterday": "Ayer",
	"comments.days_ago": "hace {count} días",
	"notifications_title": "Notificaciones",
	"notifications_mark_all_read": "Marcar todo como leído",
	"notifications_clear_all": "Limpiar todo",
	"notifications_all_up_to_date": "¡Estás al día con todo!",
	"notifications_marked_all_read": "Todas las notificaciones marcadas como leídas",
	"notifications_close_drawer": "Cerrar panel de notificaciones",
	"view_all": "Ver todo",
	"confirm_bulk_enrollment_title": "Confirmar inscripción masiva",
	"course_library_enroll_button": "INSCRIBIRSE",
	"course_library_overview_tab": "Descripción General",
	"course_library_lessons_tab": "Lecciones",
	"course_library_breadcrumb_courses": "Cursos",
	"course_overview_title": "Descripción del curso",
	"course_overview_number_of_lessons": "Número de lecciones:",
	"course_lessons_table_title": "Título",
	"course_lessons_table_subtitle": "Subtítulo",
	"course_lessons_table_duration": "Duración",
	"course_lessons_title": "Lecciones",
	"course_lessons_table_total_rows": "Filas totales:",
	"common_unsaved_changes_title": "Los cambios no guardados se perderán",
	"common_unsaved_changes_message": "Perderás el trabajo no guardado si sales ahora. ¿Deseas continuar?",
	"common_exit": "Salir",
	"common_keep_editing": "Seguir editando",
	"bulk_playlist_enrollment_modal_title": "Inscribir usuarios en el Playlist",
	"bulk_playlist_enrollment_modal_content_1": "Al inscribir a un usuario en una lista de reproducción, se agregará la capacitación a la parte superior del feed de capacitación de su empleado.",
	"bulk_playlist_enrollment_modal_content_2": "Importante: tenga en cuenta que priorizar los cursos puede hacer que otros elementos bajen en la lista y afectar las fechas de vencimiento de otros cursos.",
	"bulk_playlist_enrollment_modal_content_3": "{{users}} usuarios seleccionados",
	"bulk_enrollment_confirm_title": "Confirmar Inscripción Masiva",
	"admin_users_list_subtitle": "Ver y gestionar el progreso del usuario",
	"playlist_award_certification_label": "Otorgar una certificación cuando los alumnos completen esta lista de reproducción",
	"playlist_select_certificate_label": "Seleccionar Certificado",
	"common_unsaved_data_title": "Los datos no guardados se perderán",
	"playlist_save_success": "Información guardada exitosamente",
	"playlist_save_error": "No se pudo guardar la información. Por favor, inténtelo de nuevo.",
	"common_name": "Nombre",
	"common_description": "Descripción",
	"common_Required": "Campo obligatorio",
	"certification_manage": "Gestionar la certificación",
	"certification_employees_awarded": "Empleados premiados",
	"certification_recently_added": "Agregado recientemente",
	"certification_add": "Agregar certificación",
	"certification_name": "Nombre de la certificación",
	"certification_code": "Código de certificación",
	"certification_granting_organization_name": "Nombre de la organización otorgante",
	"certification_expiration": "Vencimiento de la certificación",
	"certification_enter_number": "Ingrese el número",
	"certification_select_expirationUnit": "Seleccionar unidad de vencimiento",
	"certification_logo": "Logotipo de la certificación",
	"invalid_file_type": "Formato de archivo inválido. Inténtalo de nuevo.",
	"file_too_large": "Elija un archivo menor a {{number}} MB.",
	"certification_empty_logo": "Cargar Logo de la Certificación",
	"course_draft_not_enrollment_description": "Por favor, publique el curso para habilitar las inscripciones de usuarios.",
	"prioritized_enrollment_tooltip_copy": "La inscripción prioritaria comenzará el próximo día disponible para los usuarios.",
	"common_paused": "Pausado",
	"streak_unpause": "Reanudar Racha",
	"streak_pause": "Pausar Racha",
	"streak_paused": "Racha Pausada",
	"streak_paused_message": "Tu racha está pausada, pero tus fechas de vencimiento continuarán según lo programado.",
	"streak_unpaused_message": "Racha pausada removida. ",
	"streak_unpause_question": "Completaste una lección, pero tu racha está pausada. ¿Quieres reactivarla?",
	"page_home": "Inicio",
	// Scheduled Reports - Overview Card Tooltips
	"scheduled_reports_tooltip_total_watch_time": "Tiempo total dedicado a ver lecciones durante este período de informe, calculado sumando la duración del video de todas las lecciones completadas.",
	"scheduled_reports_tooltip_users_with_completed_lessons": "Porcentaje de usuarios que completaron al menos una lección durante este período de informe.",
	"scheduled_reports_tooltip_average_watch_time": "Tiempo promedio dedicado a ver lecciones por usuario, calculado dividiendo el tiempo total de visualización por el número total de usuarios.",
	"scheduled_reports_tooltip_completed_lessons": "Número total de lecciones completadas por todos los usuarios durante este período de informe.",
	"scheduled_reports_tooltip_completed_courses": "Número total de cursos completados por todos los usuarios durante este período de informe.",
	"scheduled_reports_tooltip_average_streak": "Racha diaria promedio en todos los usuarios. Al momento en que se generó este informe.",
	"scheduled_reports_tooltip_overdue_lessons": "Número total de lecciones que han pasado su fecha de vencimiento y aún no se han completado.",
	"scheduled_reports_tooltip_utilization": "Porcentaje de suscriptores activos que completaron al menos una lección durante este período de informe."
};